import CollectionBannerCarousel from '@/modules/collection-banner';

const collectionBannerCarousel = document.querySelector('.js-collection-banner-carousel');
if (collectionBannerCarousel) {
    new CollectionBannerCarousel(collectionBannerCarousel)
}
